import moment from "moment-timezone";

const HINAN_CHECKIN_GAME_SPACE_IDS = new Set([
  "cmunx0pg90000mnzc5f0yg7iv",
  "cmt8v3v940001a4zc1b2v7nvx",
  "cmvwcgsza000008nyfbk364fl",
]);

export const HINAN_CHECKIN_EXPORT_BASE_URL =
  process.env.REACT_APP_HINAN_CHECKIN_EXPORT_BASE_URL ||
  "https://d3hmdg57pe8bs.cloudfront.net";

export function buildCheckInHistoryCsvUrl(batchDateJst, gameSpaceId) {
  if (!HINAN_CHECKIN_GAME_SPACE_IDS.has(gameSpaceId)) {
    return null;
  }

  const requestedDate = moment(batchDateJst, "YYYY-MM-DD", true).tz("Asia/Tokyo");
  if (!requestedDate.isValid()) {
    return null;
  }

  // 当日分のCSVはJST 23:00のバッチ実行前には未生成のため、
  // 本日または未来日が指定された場合は前日分を参照する。
  const todayJst = moment.tz("Asia/Tokyo").startOf("day");
  const effectiveDate = requestedDate.isSameOrAfter(todayJst, "day")
    ? todayJst.clone().subtract(1, "day")
    : requestedDate;
  const year = effectiveDate.format("YYYY");
  const month = effectiveDate.format("MM");
  const day = effectiveDate.format("DD");
  const baseUrl = HINAN_CHECKIN_EXPORT_BASE_URL.replace(/\/+$/, "");

  return `${baseUrl}/hinan-kunren/${gameSpaceId}/${year}/${month}/${day}/checkin-history.csv`;
}
